export const route = 'get15DayForecast';

export const layoutConfig = {
  '1x1': {
    visibleCount: ({ compact1x1VisibleCount }) => compact1x1VisibleCount,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.5rem, 48%, 5rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.25rem 0.35rem' },
    compactTimeUpdate: true,
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 p-1',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    showDateHeading: false,
    detailsClassName: 'px-1 pt-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 2),
    }),
    detailsIconSize: 14,
    detailGroups: [
      ['high', 'low', 'comfort'],
      ['windSpeed', 'windDirection', 'skyCondition'],
      ['humidity', 'precipitationProbability', 'dewPoint'],
    ],
  },
  '1x2': {
    visibleCount: ({ compact1x2ColumnCount }) => compact1x2ColumnCount * 2,
    selectorMode: 'grid',
    selectorHeight: 'clamp(8.5rem, 56%, 13rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.45rem' },
    compactTimeUpdate: false,
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 p-1',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    showDateHeading: false,
    detailsClassName: 'px-2 pt-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 16,
    detailGroups: [
      [
        'high',
        'low',
        'comfort',
        'dewPoint',
        'windSpeed',
        'windDirection',
        'humidity',
        'precipitationProbability',
        'skyCondition',
      ],
    ],
  },
  '2x1': {
    visibleCount: () => 7,
    selectorMode: 'row',
    selectorHeight: 'clamp(4.75rem, 48%, 6.75rem)',
    selectorGap: 8,
    selectorTileStyle: { padding: '0.45rem' },
    compactTimeUpdate: false,
    wrapperClassName: 'd-flex flex-column w-100 h-100 overflow-hidden',
    contentClassName: 'd-flex flex-column w-100 px-2 pb-2',
    contentStyle: { flex: '1 1 0', minHeight: 0 },
    showDateHeading: true,
    detailsClassName: 'pt-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize.baseFontSize - 1),
    }),
    detailsIconSize: 16,
    detailGroups: [
      ['high', 'low', 'comfort'],
      ['windSpeed', 'windDirection', 'skyCondition'],
      ['humidity', 'precipitationProbability', 'dewPoint'],
    ],
  },
};
